<template>
    <div :data-component="$options.name">
        <iw-expose-public
            ref="webComponentRef"
            :identifier="estate.exposeeId"
        />
    </div>
</template>
<script lang="ts" src="./MsDetailPartnerWebComponent.ts" />
